var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.isOpen
      ? _c("div", { attrs: { id: "all-notification-dropdown" } }, [
          _c(
            "div",
            { staticClass: "dropdown-menu show" },
            [
              _c(
                "div",
                { staticClass: "dropdown-item dropdown-header text-center" },
                [
                  _c("h4", { staticClass: "m-0" }, [
                    _vm._v("All Notifications")
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button", "aria-label": "Close" },
                      on: { click: _vm.toggle }
                    },
                    [_c("i", { staticClass: "nc-icon nc-simple-remove" })]
                  )
                ]
              ),
              _vm._v(" "),
              _vm._l(_vm.notificationList, function(notification, index) {
                return _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.hover",
                        value: notification.hasLongText,
                        expression: "notification.hasLongText",
                        modifiers: { hover: true }
                      }
                    ],
                    key: index,
                    staticClass: "dropdown-item",
                    class: { read: !notification.unread },
                    attrs: {
                      title: notification.hasLongText
                        ? notification.title
                        : null,
                      href: "#" + notification.href
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        _vm.readNotification(notification.id, notification.href)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(notification.title) +
                        "\n              "
                    ),
                    _c(
                      "small",
                      { staticClass: "time" },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: ["far", "clock"] }
                        }),
                        _vm._v(" " + _vm._s(notification.createdAt))
                      ],
                      1
                    )
                  ]
                )
              }),
              _vm._v(" "),
              _c("infinite-loading", { on: { infinite: _vm.infiniteHandler } })
            ],
            2
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isOpen
      ? _c("div", { staticClass: "close-fixed", on: { click: _vm.close } })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b940ad8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b940ad8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Layout/Notifications/Side.vue
// module id = yCxy
// module chunks = 4